/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {StorageService as ɵb} from './lib/service/storage.service';
export {Config as ɵa} from './lib/tokens';